import { Injectable, OnDestroy } from '@angular/core';
import { CustomGridHeaderComponent } from '../ag-grid-components/custom-grid-header/custom-grid-header.component';
import { SalesTrendsGridConfigService } from './sales-trends-grid-config.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesTrendQtyGridService implements OnDestroy {
  today = new Date().getTime();
  month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  currentYear: number = new Date().getFullYear();
  private destroy$ = new Subject<void>();
  quartely: any[] = [
    { value: "quarter1", months: "Jan"  + " " + this.currentYear + "-" + "Mar" + " "+ this.currentYear },
    { value: "quarter2", months: "Apr" + " " + this.currentYear + "-" +"Jun" + " "+ this.currentYear },
    { value: "quarter3", months: "Jul" + " "+ this.currentYear + "-" + "Sep" + " "+ this.currentYear },
    { value: "quarter4", months: "Oct" + " " + this.currentYear + "-" + "Dec" + " "+ this.currentYear }
  ];
  date = new Date();
  sortModel:any[]=[]
  selectedWeek: any = [
    {
      label: 'This week',
      from: new Date(this.today - this.getDaysAgo(7)),
      to: new Date(this.today),
      checked:true
    },
    {
      label: 'Last week',
      from: new Date(this.today - this.getDaysAgo(14)),
      to: new Date(this.today),
      checked:true
    },
    {
      label: '2 weeks ago',
      from: new Date(this.today - this.getDaysAgo(21)),
      to: new Date(this.today),
      checked:true
    },
    {
      label: "3 weeks ago",
      from: new Date(this.today - this.getDaysAgo(28)),
      to: new Date(this.today),
      checked:true
    },
    {
      label: "4 weeks ago",
      from: new Date(this.today - this.getDaysAgo(35)),
      to: new Date(this.today),
      checked:true
    }
  ];
  constructor(private salesTrendsGridConfigService : SalesTrendsGridConfigService) { }

  qtyColumnDefs: any = [
    {
      headerName: "Revenue",
      marryChildren: true,
      children: [
        {
          headerName: "This week",
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1SalesDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1Sales",
          backendFields:["G1Sales","G1SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          isSumColumns:true,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Last week",
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",            
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2SalesDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2Sales",
          backendFields:["G2Sales","G2SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          isSumColumns:true,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "2 weeks ago",
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          isSumColumns:true,
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3SalesDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3Sales",
          backendFields:["G3Sales","G3SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "3 weeks ago",
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          isSumColumns:true,
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4SalesDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4Sales",
          backendFields:["G4Sales","G4SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "4 weeks ago",
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          isSumColumns:true,
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5SalesDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5Sales",
          backendFields:["G5Sales","G5SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Qty Sold",
      marryChildren: true,
      children: [
        {
          headerName: "This week",
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          isSumColumns:true,
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1QtySoldDiff,
              isQtySold:true
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1QtySold",
          backendFields:["G1QtySold","G1QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Last week",
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2QtySoldDiff,
              isQtySold:true
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2QtySold",
          isSumColumns:true,
          backendFields:["G2QtySold","G2QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "2 weeks ago",
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3QtySoldDiff,
              isQtySold:true
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3QtySold",
          isSumColumns:true,
          backendFields:["G3QtySold","G3QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "3 weeks ago",
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4QtySold",
          backendFields:["G4QtySold","G4QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "4 weeks ago",
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5QtySold",
          backendFields:["G5QtySold","G4QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Returns",
      marryChildren: true,
      children: [
        {
          headerName: "This week",
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1Returns",
          backendFields:["G1Returns","G1ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Last week",
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          isSumColumns:true,
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ReturnsDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2Returns",
          backendFields:["G2Returns","G2ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "2 weeks ago",
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          isSumColumns:true,
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ReturnsDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3Returns",
          backendFields:["G3Returns","G3ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "3 weeks ago",
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ReturnsDiff,
              }
          },
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4Returns",
          backendFields:["G4Returns","G4ReturnsDiff"],
          sortable: true,
          width: 90,
          isSumColumns:true,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "4 weeks ago",
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ReturnsDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5Returns",
          backendFields:["G5Returns","G5ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Profit",
      marryChildren: true,
      children: [
        {
          headerName: "This week",
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1Profit",
          backendFields:["G1Profit","G1ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "Last week",
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2Profit",
          backendFields:["G2Profit","G2ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "2 weeks ago",
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3Profit",
          backendFields:["G3Profit","G3ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "3 weeks ago",
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4Profit",
          backendFields:["G4Profit","G4ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: "4 weeks ago",
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5Profit",
          backendFields:["G5Profit","G5ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
  ];

  qtyMonthColumn= [
    {
      headerName: "Revenue",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1Sales",
          backendFields:["G1Sales","G1SalesDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2Sales",
          backendFields:["G2Sales",,"G2SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3Sales",
          backendFields:["G3Sales","G3SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4Sales",
          backendFields:["G4Sales","G4SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5Sales",
          backendFields:["G5Sales","G5SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Qty Sold",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1QtySold",
          backendFields:["G1QtySold","G1QtySoldDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2QtySold",
          backendFields:["G2QtySold","G2QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3QtySold",
          backendFields:["G3QtySold","G3QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4QtySold",
          backendFields:["G4QtySold","G4QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5QtySold",
          backendFields:["G5QtySold","G5QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Returns",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ReturnsDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1Returns",
          backendFields:["G1Returns","G1ReturnsDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2Returns",
          backendFields:["G2Returns","G2ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3Returns",
          backendFields:["G3Returns","G3ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4Returns",
          backendFields:["G4Returns","G4ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5Returns",
          backendFields:["G5Returns","G5ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Profit",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1Profit",
          backendFields:["G1Profit","G1ProfitDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2Profit",
          backendFields:["G2Profit","G2ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3Profit",
          backendFields:["G3Profit","G3ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4Profit",
          backendFields:["G4Profit","G4ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "spray",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G5ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G5Profit",
          backendFields:["G5Profit","G5ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
  ];

  qtyQuarterlyColumn= [
    {
      headerName: "Revenue",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1Sales",
          backendFields:["G1Sales","G1SalesDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2Sales",
          backendFields:["G2Sales","G2SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '', 
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G3Sales",
          backendFields:["G3Sales","G3SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',

          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4SalesDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4Sales",
          backendFields:["G4Sales","G4SalesDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Qty Sold",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G1QtySold",
          backendFields:["G1QtySold","G1QtySoldDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G2QtySold",
          backendFields:["G2QtySold","G2QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '', 
          headerClass: "purple",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          filter: "agNumberColumnFilter",
          field: "G3QtySold",
          backendFields:["G3QtySold","G3QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4QtySoldDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.onHeaderCallback.bind(this)
          },
          field: "G4QtySold",
          backendFields:["G4QtySold","G4QtySoldDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Returns",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G1Returns",
          backendFields:["G1Returns","G1ReturnsDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G2Returns",
          backendFields:["G2Returns","G2ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '', 
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G3Returns",
          backendFields:["G3Returns","G3ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ReturnsDiff,
              isQtySold:true
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G4Returns",
          backendFields:["G4Returns","G4ReturnsDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
    {
      headerName: "Profit",
      marryChildren: true,
      children: [
        {
          headerName: '',
          headerClass: "orange",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G1ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G1Profit",
          backendFields:["G1Profit","G1ProfitDiff"],
          sortable: true,
          width: 100,
          minWidth: 100,

          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "primary-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G2ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G2Profit",
          backendFields:["G2Profit","G2ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '', 
          headerClass: "purple",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G3ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G3Profit",
          backendFields:["G3Profit","G3ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
        {
          headerName: '',
          headerClass: "success-light",
          filter: "agNumberColumnFilter",
          cellRenderer : "salesTrendsCellRendere",
          cellRendererParams:(params) =>{
            return {
              difference: params.data.G4ProfitDiff,
              }
          },
          isSumColumns:true,
          headerComponent: CustomGridHeaderComponent,
          headerComponentParams :{
            isSalesTrend:true,
            callback: this.salesTrendsGridConfigService.onHeaderCallback.bind(this,this.salesTrendsGridConfigService.gridApi)
          },
          field: "G4Profit",
          backendFields:["G4Profit","G4ProfitDiff"],
          sortable: true,
          width: 90,
          minWidth: 90,
          cellStyle: (cell) =>
            this.isFirstColumn(cell)
              ? { "border-left": "2px solid #D6D6D6" }
              : null,
        },
      ],
    },
  ];

  isFirstColumn(cell) {
    return (
      cell.column.colId === cell.column.parent.displayedChildren[0].colId &&
      cell.column.parent.displayedChildren[0].instanceId != 0
    );
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  onHeaderCallback(e){
    this.sortModel=e;
    this.salesTrendsGridConfigService.gridApi.refreshServerSide({ route: [], purge: true });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
